var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoAyuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 16.7766C13 17.3289 12.5523 17.7766 12 17.7766C11.4477 17.7766 11 17.3289 11 16.7766C11 16.2243 11.4477 15.7766 12 15.7766C12.5523 15.7766 13 16.2243 13 16.7766ZM12.6688 11.3298C13.4306 10.9956 13.8345 10.1447 13.6141 9.33952C13.3856 8.53671 12.5943 8.02165 11.7728 8.13519C10.9498 8.24894 10.3261 8.95994 10.3261 9.7964C10.3261 10.316 9.91095 10.7312 9.39133 10.7312C8.87171 10.7312 8.45654 10.316 8.45654 9.7964C8.45654 8.03351 9.77122 6.52689 11.5135 6.28378C13.2561 6.04062 14.9354 7.13274 15.4119 8.83527C15.8882 10.5286 15.028 12.3369 13.4189 13.0453L13.4174 13.046C13.1232 13.1744 12.9348 13.4628 12.9348 13.7877V14.1442C12.9348 14.6682 12.4977 15.0703 12 15.0703C11.4804 15.0703 11.0652 14.6551 11.0652 14.1355C11.0652 12.9461 11.5067 11.8406 12.6688 11.3298Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAyuda);
export default __webpack_public_path__ + "static/media/Icono_ayuda.a5468b962822e7943689641c907cb86f.svg";
export { ForwardRef as ReactComponent };